
export class ProviderPoliciesModel {
  realTimePolicy: string;
  auditPolicy: string;
  permanentAuditPolicy: string;
  policies: string[];
}
